import { TotSelect } from 'src/app/models/totselect.interface';

export interface TotSelectState {
  totSelect: TotSelect;
}

export const initialTotSelectState: TotSelectState = {
  totSelect: {
    pal: 0,
    avv: 0,
    palPsr: '0',
    concPsr: '0',
    tcPsr: 0,
    total: 0,
    totalTicket: 0,
    multi: 1,
    combinazioni: 0,
    session: '',
    scoSel: null,
    sisSel: null,
    scommesse: [],
    sistemi: [
      {
        text: 'X1',
        command: 'selectX1',
        value: 0,
        scommessa: [1],
        map: 1,
        fam: 'X',
        disabled: false,
      },
      {
        text: 'X12',
        command: 'selectX12',
        value: 1,
        scommessa: [2],
        map: 1,
        fam: 'X',
        disabled: false,
      },
      {
        text: 'X13',
        command: 'selectX13',
        value: 2,
        scommessa: [3],
        map: 1,
        fam: 'X',
        disabled: false,
      },
      {
        text: 'X14',
        command: 'selectX14',
        value: 3,
        scommessa: [4],
        map: 1,
        fam: 'X',
        disabled: false,
      },
      {
        text: 'X15',
        command: 'selectX15',
        value: 4,
        scommessa: [5],
        map: 1,
        fam: 'X',
        disabled: false,
      },
      {
        text: 'X16',
        command: 'selectX16',
        value: 5,
        scommessa: [6],
        map: 1,
        fam: 'X',
        disabled: false,
      },
      {
        text: 'NX',
        command: 'selectNX',
        value: 6,
        scommessa: [1, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        map: 1,
        fam: 'N',
        disabled: false,
      },
      {
        text: 'P1',
        command: 'selectP1',
        value: 7,
        scommessa: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        map: 2,
        fam: 'P',
        disabled: false,
      },
      {
        text: 'P2',
        command: 'selectT2',
        value: 8,
        scommessa: [9, 10, 11, 12, 13, 14, 15, 16],
        map: 2,
        fam: 'P',
        disabled: false,
      },
      {
        text: 'P3',
        command: 'selectP3',
        value: 9,
        scommessa: [11, 12, 13, 14, 15, 16],
        map: 2,
        fam: 'P',
        disabled: false,
      },
      {
        text: 'P4',
        command: 'selectP4',
        value: 10,
        scommessa: [13, 14, 15, 16],
        map: 2,
        fam: 'P',
        disabled: false,
      },
      {
        text: 'P5',
        command: 'selectP5',
        value: 11,
        scommessa: [15, 16],
        map: 2,
        fam: 'P',
        disabled: false,
      },
      {
        text: 'V1',
        command: 'selectV1',
        value: 12,
        scommessa: [8, 10, 12, 14, 16],
        map: 2,
        fam: 'V',
        disabled: false,
      },
      {
        text: 'V2',
        command: 'selectV2',
        value: 13,
        scommessa: [10, 12, 14, 16],
        map: 2,
        fam: 'V',
        disabled: false,
      },
      {
        text: 'V3',
        command: 'selectV3',
        value: 14,
        scommessa: [12, 14, 16],
        map: 2,
        fam: 'V',
        disabled: false,
      },
      {
        text: 'V4',
        command: 'selectV4',
        value: 15,
        scommessa: [14, 16],
        map: 2,
        fam: 'V',
        disabled: false,
      },
      {
        text: 'V5',
        command: 'selectV5',
        value: 16,
        scommessa: [16],
        map: 2,
        fam: 'V',
        disabled: false,
      },
      {
        text: 'T2',
        command: 'selectT2',
        value: 17,
        scommessa: [8],
        map: 2,
        fam: 'T',
        disabled: false,
      },
      {
        text: 'T3',
        command: 'selectT3',
        value: 18,
        scommessa: [10],
        map: 3,
        fam: 'T',
        disabled: false,
      },
      {
        text: 'T4',
        command: 'selectT4',
        value: 19,
        scommessa: [12],
        map: 4,
        fam: 'T',
        disabled: false,
      },
      {
        text: 'T5',
        command: 'selectT5',
        value: 20,
        scommessa: [14],
        map: 5,
        fam: 'T',
        disabled: false,
      },
      {
        text: 'T6',
        command: 'selectT6',
        value: 21,
        scommessa: [16],
        map: 6,
        fam: 'T',
        disabled: false,
      },
    ],
    maps: [[], [], [], [], [], []],
    scoTot: [],
    scoPsr: [],
    stateQuick: {
      esi: 0,
      idTicket: '',
      description: '',
    },
    state: {
      esi: 0,
      idTicket: '',
      description: '',
    },
    race: '0'
  },
};
